module.exports = __webpack_public_path__ + "static/media/ukfIMG.f9d1540a.png";